import BaseModel from '../model/BaseModel';

export default class LoyaltyCard extends BaseModel {

    constructor(data) {
        super(data);
        this.SessionId = data ? data.SessionId : undefined;
        this.CinemaId = data ? data.CinemaId : undefined;
        this.TicketType = data ? data.TicketType : undefined;
        this.CardNumber = data ? data.MemberCard : undefined;
        this.MemberCard = data ? data.MemberCard : undefined;
        this.Qty = data && data.Qty ? data.Qty : 1;
        this.MemberProviderName = data ? data.MemberProviderName : undefined;
        this.RecognitionID = data ? data.RecognitionID : undefined;
        this.SequenceNumber = data ? data.SequenceNumber: undefined;
        this.Barcode = data ? data.Barcode : undefined;
        this.Error = undefined;
    }

    clear(){
        this.SessionId =  undefined;
        this.CinemaId =  undefined;
        this.TicketType =  undefined;
        this.MemberCard =  undefined;
        this.Qty =  1;
        this.Name = undefined;
        this.Error = undefined;
    }

    setSessionInfo(SessionId, CinemaId) {
        this.SessionId = SessionId;
        this.CinemaId = CinemaId;
    }

    get TicketTypeCode() {
        return this.TicketType ? this.TicketType.TicketTypeCode : undefined;
    }

    get isPopulated() {
        var hasTicketTypeCode = !!this.TicketTypeCode ;
        var hasNumber = !!(this.MemberCard && this.MemberCard != '');
        return hasTicketTypeCode && hasNumber;
    }

    toJSON(){
        return {
            SessionId:this.SessionId,
            CinemaId:this.CinemaId,
            TicketTypeCode:this.TicketTypeCode,
            MemberCard:this.MemberCard,
            TicketType:this.TicketType,
            Qty:this.Qty
        }
    }
}




// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/LoyaltyCard.js